import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { Accent, SectionHeading } from './SectionHeading';

/** Section 7 — the actual product pages. */
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-133" data-mp="2h5d7p1qrh10z">
      <div className="mx-auto max-w-6xl" data-id="element-134" data-mp="2d3s11y4tliz8">
        <SectionHeading id="inside-heading" eyebrow="Real Pages From Volume 4" title={<>
              Don't Just Take Our Word for It. <Accent data-id="element-136" data-mp="235vmsxgl67ww">Look Inside.</Accent>
            </>} body="These aren't empty ebooks filled with generic theory." data-id="element-135" data-mp="2d2qkje51c4a4" />

        <div className="mt-12" data-id="element-137" data-mp="1u5yywy20td2w">
          <InsidePagesCarousel data-id="element-138" data-mp="1u70kvxkkrjze" />
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-139" data-mp="1u8bnhu2aalox">
          Professional resources designed to be <Accent data-id="element-140" data-mp="3okrnid4hl3lc">used</Accent> — not just read.
        </p>
      </div>
    </section>;
}